module.exports = __webpack_public_path__ + "images/icon/action_menu-c6c9248e.svg";